import { styled } from "styled-components";

export const HomeContainer = styled.div`
  h2 {
    text-align: center;
    margin-bottom: 3rem;
  }

  a.products-btn {
    margin: 3rem auto 0;
  }
`;

export const HomeIconContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 25%;
  padding: 1.5rem;
  border-radius: var(--radius-md);
  transition: var(--transition);

  &:hover {
    background: var(--lighter);
    box-shadow: var(--shadow-soft);
    transform: translateY(-5px);
  }

  img {
    margin-right: 1.5rem;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
  }

  p {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.4;
    color: var(--lead);
  }

  @media only screen and (max-width: 1050px) {
    max-width: 85%;
    margin: 0 auto 2rem;
    
    &:not(:last-child) {
      margin-bottom: 2rem;
    }
  }
`;

export const HomeProductsContainer = styled.div`
  display: grid;
  gap: 5rem;
  grid-template-columns: repeat(4, 1fr);

  @media only screen and (max-width: 1600px) {
    gap: 3rem;
  }

  @media only screen and (max-width: 1300px) {
    gap: 2rem;
  }

  @media only screen and (max-width: 1050px) {
    gap: 4rem;
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 600px) {
    gap: 2rem;
  }

  @media only screen and (max-width: 500px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const HomeQuoteContainer = styled.div`
  display: flex;
  margin-top: 8rem;

  div.text-container {
    margin-right: 3rem;
  }

  h2 {
    font-size: 64px;
    font-weight: 800;
    line-height: 90px;
    text-align: left;

    & > span {
      font-family: "Raleway", sans-serif;
      background: var(--yellow);
      padding: 0.25rem;
    }
  }

  p {
    font-size: 20px;
    line-height: 1.6;
    color: var(--grey1);

    &.quote {
      font-family: "Raleway", sans-serif;
      font-size: 22px;
      font-weight: 700;
      color: var(--lighter);
      background: rgba(3, 3, 3, 0.75);
      backdrop-filter: blur(10px);
      text-align: center;
      border-radius: var(--radius-md);
      padding: 2.5rem 3rem;
      position: absolute;
      bottom: 3rem;
      left: 50%;
      transform: translateX(-50%);
      width: 75%;
      box-shadow: var(--shadow-medium);
      border: 1px solid rgba(255, 255, 255, 0.1);

      &::before {
        content: '"';
        font-size: 80px;
        color: var(--yellow);
        position: absolute;
        top: -10px;
        left: 20px;
        opacity: 0.5;
        font-family: serif;
      }
      &.mobile {
        position: fixed;
        background: var(--lighter);
        z-index: 100;
        top: 0;
        left: 100%;
        width: 100%;
        height: 100%;
        padding: 2rem var(--hPadding);
        margin-right: 0;
        overflow-y: auto;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);

        &.active {
          left: 0;
        }

        .material-symbols-rounded {
          font-size: 32px;
          color: var(--blue);
        }

        h3 {
          font-size: 24px;
        }
      }
    }
  }

  @media only screen and (max-width: 1050px) {
    display: block;
    text-align: center;
    margin-top: 5rem;

    h2 {
      text-align: center;
      font-size: 48px;
      line-height: 1.2;
    }

    div.text-container {
      margin: 0 0 4rem;
    }

    img {
      display: block;
      width: 100%;
      border-radius: var(--radius-lg);
    }
  }

  @media only screen and (max-width: 600px) {
    h2 {
      font-size: 36px;
    }

    p {
      font-size: 18px;
    }

    p.quote {
      width: 90%;
      font-size: 18px;
      padding: 1.5rem;
      bottom: 1.5rem;

      &::before {
        font-size: 50px;
      }
    }
  }

  @media only screen and (max-width: 400px) {
    h2 {
      font-size: 32px;
      line-height: 1.3;
    }
  }
`;
